module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hlist"
  }, [_c('ul', {
    staticClass: "list_ch clearfix"
  }, _vm._l((_vm.list), function(lis, index) {
    return _c('li', {
      key: index
    }, [_c('a', {
      attrs: {
        "href": '#/detail/' + lis.iid
      }
    }, [_c('img', {
      attrs: {
        "src": lis.image
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "li_title"
    }, [_vm._v(_vm._s(lis.title))]), _vm._v(" "), _c('p', {
      staticClass: "mo_price"
    }, [_vm._v(_vm._s(lis.price)), _c('span', {
      staticClass: " collect"
    }), _c('span', {
      staticClass: "count"
    }, [_vm._v(_vm._s(lis.cfav))])])])])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isshowmore || _vm.wasmore),
      expression: "isshowmore || wasmore"
    }],
    staticClass: "weui-loadmore"
  }, [_c('i', {
    staticClass: "weui-loading"
  }), _vm._v(" "), _c('span', {
    staticClass: "weui-loadmore__tips"
  }, [_vm._v("正在加载")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isnone),
      expression: "isnone"
    }],
    staticClass: "weui-loadmore weui-loadmore_line"
  }, [_c('span', {
    staticClass: "weui-loadmore__tips"
  }, [_vm._v("暂无数据")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-e4dc27b0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-e4dc27b0","hasScoped":true}!./node_modules/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./app/component/pchlist.vue
// module id = 214
// module chunks = 0